import BaseAddEditModal from '../components/base/BaseAddEditModal';
import React from 'react';

const AddEditNewsModal = ({ isOpen, onClose, initialData, onSave,isEdit }) => {
  const dataStructure = {
    title: { type: 'text', label: 'Title', required: true },
    image_url: { type: 'image', label: 'Image', required: true },
    description: { type: 'rich-text', label: 'Description', required: true },
    url: { type: 'text', label: 'URL', required: false },
    sort_order: { type: 'number', label: 'Sort Order', required: false },
    start_date: { type: 'date', label: 'Start Date', required: true },
    end_date: { type: 'date', label: 'End Date', required: true },
  };

  return (
    <BaseAddEditModal
      isEdit={isEdit}
      isOpen={isOpen}
      onClose={onClose}
      initialData={initialData}
      onSave={onSave}
      dataStructure={dataStructure}
      tableName="latest_news"
      isMultiLanguageSupported={true}
    />
  );
};

export default AddEditNewsModal;








